import React from "react";

const HeaderTopRecentMatches = () => {
  return (
    <React.Fragment>
      <div className="block @md:flex bg-header-blue dark:bg-league-dark py-1 items-center justify-between rounded-t-lg w-full gap-x-0 mt-1">
        <div className="flex flex-wrap items-center justify-between gap-0">
          <div className="flex flex-wrap gap-0 ml-3">
            <div className="w-[1.5rem] py-1"></div>
          </div>
          <div className="flex flex-wrap gap-0 mx-0 @xl:mx-3">
            <div className="w-[2rem] @md:w-[4rem] py-1 mx-1">
              <div className="flex-1 flex items-center justify-center text-button-blue-bet dark:text-stroke-o3 text-xs font-semi-bold">Giờ</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-0 mr-0 @xl:mr-3">
            <div className="flex gap-0">
              <div className="w-[2rem] @md:w-12"></div>
              <div className="w-12">
               <div className="flex-1 flex items-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Giải</div>
              </div>
            </div>
            <div className="flex gap-0">
              <div className="w-[1.5rem]">
                <div className="flex-1 flex items-center justify-center text-button-blue-bet text-xs font-semi-bold"></div>
              </div>
            </div>
            <div className="flex gap-0">
              <div className="min-w-10 @md:w-56">
                <div className="text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Đội</div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-0 mr-1 @xl:mr-3">
            <div className="flex-1 flex items-center justify-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold w-[4rem] @md:w-auto text-ellipsis overflow-hidden whitespace-nowrap ml-2">Tỉ số/Thẻ</div>
          </div>
          <div className="flex flex-wrap gap-0 ml-3">
            <div className="w-[2.5rem]">
              <div className="flex-1 flex items-center justify-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Góc</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeaderTopRecentMatches;